import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import type { Blocker } from 'react-router'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { DialogDescription } from '~/components/ui/dialog'
import { Size } from '~/types/ThemeTypes'

interface UnsavedChangesDialogProps {
  blocker: Blocker
}

export const UnsavedChangesDialog = ({
  blocker,
}: UnsavedChangesDialogProps) => {
  const { t } = useTranslation()
  return (
    <MangoModal
      open={blocker.state === 'blocked'}
      onClose={() => blocker.reset?.()}
      role="alertdialog"
      header={t('unsavedChangesDialog.title', 'Unsaved changes')}
      footer={
        <Flex gap={2}>
          <MangoButton
            size={Size.sm}
            variant={MangoButtonVariant.Default_200}
            onClick={() => blocker.reset?.()}
          >
            {t('unsavedChangesDialog.stay', 'Stay on page')}
          </MangoButton>
          <MangoButton
            size={Size.sm}
            variant={MangoButtonVariant.Destructive_300}
            onClick={() => blocker.proceed?.()}
          >
            {t('unsavedChangesDialog.discard', 'Discard changes')}
          </MangoButton>
        </Flex>
      }
    >
      <DialogDescription color="inherit">
        {t(
          'unsavedChangesDialog.body',
          'You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.',
        )}
      </DialogDescription>
    </MangoModal>
  )
}
